import React, { useContext } from "react";
import Elements from "@Components/Elements";
import PageContext from "@PageContext";
import useConsent from "../../hooks/useConsent.js";

const Default = () => {
	const { REACT_APP_PATH } = process.env;
	const [pageData] = useContext(PageContext);
	const { id, lang } = pageData;
	const consent = useConsent();

	return (
		<>
			<Elements />
			<micado-ial
				key={consent}
				language={lang}
				page-id={id}
				path={REACT_APP_PATH}
			></micado-ial>
		</>
	);
};

export default Default;
